import { SantaSpinnerSizeType, SantaSpinnerType } from '@alliance/santa/models'
import { IconLoaderRedLarge, IconLoaderRedNormal, IconLoaderWhiteLarge, IconLoaderWhiteNormal, IconName } from '@alliance/shared/icons'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'santa-spinner-loader',
  templateUrl: './spinner-loader.component.html',
  styleUrls: ['./spinner-loader.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerLoaderComponent {
  @Input() public loading = true
  @Input() public spinnerWithBackground = false
  @Input() public spinnerSize: SantaSpinnerSizeType = 'normal'
  @Input() public spinnerType: SantaSpinnerType = 'red'

  public readonly iconsMap: Record<SantaSpinnerType, Record<SantaSpinnerSizeType, IconName>> = {
    red: {
      normal: IconLoaderRedNormal.name,
      large: IconLoaderRedLarge.name
    },
    white: {
      normal: IconLoaderWhiteNormal.name,
      large: IconLoaderWhiteLarge.name
    }
  }
}
